import Image from "next/image";
import Link from "next/link";
import { baseURL } from "../categories/categoryItem";
import Likes from "../likes";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow } from "../../redux/counterSlice";
// https://api.impactoverse.com/api/app/list-assets?limit=75&offset=0&isSold=false&priceMin=0&priceMax=100000000000000000&percentageMin=0&percentageMax=100&impactCategory=&nftCategory=&username=&itemName=

const ImpactGridItems = ({ assetsList }) => {
  const items = [
    {
      id: 1,
      imageSrc: "/images/collections/collection_square_1.jpg",
      alt: "item 1",
      itemName: "Art Me Outside",
      price: "1.55 ETH",
      lastSale: "1.3 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043119491_508648_IMG_8551.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 2,
      imageSrc: "/images/collections/collection_square_2.jpg",
      alt: "item 2",
      itemName: "PankySkal",
      price: "2.3 ETH",
      lastSale: "0.5 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043246508_930662_IMG_8552.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 3,
      imageSrc: "/images/collections/collection_square_3.jpg",
      alt: "item 3",
      itemName: "VR Space_287",
      price: "5.6 ETH",
      lastSale: "3.4 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043246508_930662_IMG_8552.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 4,
      imageSrc: "/images/collections/collection_square_4.jpg",
      alt: "item 4",
      itemName: "Metasmorf",
      price: "1.4 ETH",
      lastSale: "0.7 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 5,
      imageSrc: "/images/collections/collection_square_5.jpg",
      alt: "item 1",
      itemName: "Art Me Outside",
      price: "1.55 ETH",
      lastSale: "1.3 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 6,
      imageSrc: "/images/collections/collection_square_6.jpg",
      alt: "item 2",
      itemName: "PankySkal",
      price: "2.3 ETH",
      lastSale: "0.5 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 7,
      imageSrc: "/images/collections/collection_square_7.jpg",
      alt: "item 3",
      itemName: "VR Space_287",
      price: "5.6 ETH",
      lastSale: "3.4 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 8,
      imageSrc: "/images/collections/collection_square_8.jpg",
      alt: "item 4",
      itemName: "Metasmorf",
      price: "1.4 ETH",
      lastSale: "0.7 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 9,
      imageSrc: "/images/collections/collection_square_9.jpg",
      alt: "item 1",
      itemName: "Art Me Outside",
      price: "1.55 ETH",
      lastSale: "1.3 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 10,
      imageSrc: "/images/collections/collection_square_10.jpg",
      alt: "item 2",
      itemName: "PankySkal",
      price: "2.3 ETH",
      lastSale: "0.5 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 11,
      imageSrc: "/images/collections/collection_square_11.jpg",
      alt: "item 3",
      itemName: "VR Space_287",
      price: "5.6 ETH",
      lastSale: "3.4 ETH",
      verified: true,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
    {
      id: 12,
      imageSrc: "/images/collections/collection_square_12.jpg",
      alt: "item 4",
      itemName: "Metasmorf",
      price: "1.4 ETH",
      lastSale: "0.7 ETH",
      verified: false,
      imageUrl: "public/creators/assets/nft_1674043545318_544213_IMG_8553.jpg",
      _id: "63c7deef1e9a0a0990ad7fa6",
      creator: {
        creatorId: "63c3e0964df378abfe55cc94",
        walletAddress: "0xa828f985f8c301af02165a5b09a6008edeb058c7",
        username: "aunuaglobal",
        avatarUrl: "",
      },
      priceUsd: 10,
    },
  ];

  const dispatch = useDispatch();

  return (
    <>
      {!!assetsList?.length &&
        assetsList.map((item) => (
          <article key={item._id}>
            <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl block border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
              <figure className="relative">
                <Link href={`/impact-token-detail/${item._id}`}>
                  <Image
                    width={230}
                    height={230}
                    src={baseURL + item.imageUrl}
                    alt="item 5"
                    className="w-full h-[230px] rounded-[0.625rem] object-cover"
                  />
                </Link>
                <div
                  onClick={() => {
                    addToFav(item._id).then((res) => {
                      successToast(res.data.message);
                    });
                  }}
                >
                  <Likes like="15" />
                </div>

                {/* <div className="absolute left-3 -bottom-3">
           <div className="flex -space-x-2">
             <Link href={`/404`}>
               <Tippy content={<span>creator: Sussygirl</span>}>
                 <Image
                   width={21}
                   height={21}
                   src="/images/avatars/creator_1.png"
                   alt="creator"
                   className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                 />
               </Tippy>
             </Link>
             <Link href={`/404`}>
               <Tippy content={<span>creator: Sussygirl</span>}>
                 <Image
                   width={21}
                   height={21}
                   src="/images/avatars/owner_1.png"
                   alt="owner"
                   className="dark:border-jacarta-600 hover:border-accent dark:hover:border-accent h-6 w-6 rounded-full border-2 border-white"
                 />
               </Tippy>
             </Link>
           </div>
         </div> */}
              </figure>
              <div className="mt-7 flex items-center justify-between">
                <Link href={`/impact-token-detail/${item._id}`}>
                  <span className="font-display text-jacarta-700 hover:text-accent text-base dark:text-white">
                    {item.itemName}
                  </span>
                </Link>

                {/* <Auctions_dropdown
                share_to={`/impact-token-detail/${item._id}`}
                classes="dark:hover:bg-jacarta-600 dropup hover:bg-jacarta-100 rounded-full "
              /> */}
              </div>

              <div className="mt-2 text-sm">
                <span className="dark:text-jacarta-200 text-jacarta-700 mr-1">
                  Creator: {item.creator.username}
                </span>
              </div>
              <div className="mt-2 text-sm">
                <span className="dark:text-jacarta-200 text-jacarta-700 mr-1">
                  Price: ${item.priceUsd}
                </span>
              </div>
              <div className="flex items-center justify-center">
                <button
                  className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all mt-4"
                  onClick={() => dispatch(buyModalShow(item))}
                >
                  BUY NOW
                </button>
              </div>
            </div>
          </article>
        ))}
    </>
  );
};

export default ImpactGridItems;
